<template>
  <div>
    <div v-if="!loading">
      <b-alert show variant="warning">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        O layout abaixo é apenas uma simulação. No aplicativo real pode haver
        diferenças.
      </b-alert>
      <b-card
        :overlay="loading"
        no-body
        class="border-0"
        style="width: 400px; height: 775px; border-radius: 55px 55px 45px 45px"
        :style="backgroundStyle"
      >
        <img
          class="img-responsive img-fluid position-absolute top-0"
          src="@/assets/img/mockups/smartphone-mockup.png"
          width="400px"
          style="min-height: 800px; max-height: 800px;"
        />
        <b-card-header
          :style="`${headerStyle}`"
          class="p-4 mt-2 smartphone-border-radius"
        >
          <b-row class="pa-2 px-3">
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-between mt-2"
            >
              <b-button
                class="border-0"
                :variant="fields.iconColor.hex8"
                @click="opened = true"
              >
                <i class="fas fa-bars" :style="`${iconStyle}`"></i>
              </b-button>
              <b-img
                v-if="companyInfo.logo"
                :src="`${getImagesAddressApp}${companyInfo.logo}`"
                fluid
                width="70%"
                class="mt-4 mr-3"
              ></b-img>
              <i class="fas fa-shopping-cart" :style="`${iconStyle}`"></i>
            </b-col>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-between mt-3 mb-3"
            >
              <b-input placeholder="Buscar produto"></b-input>
              <i class="fas fa-search ml-2 mr-2" :style="`${iconStyle}`"></i>
              <i class="fas fa-camera ml-2" :style="`${iconStyle}`"></i>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-text class="px-5 pt-5 mb-5" style="overflow: auto; z-index: 1">
          <slot
            :categories="fields.categories"
            :iconStyle="iconStyle"
            :fontStyle="fontStyle"
            :backgroundStyle="backgroundStyle"
            :headerStyle="headerStyle"
            :companyInfo="companyInfo"
          />
        </b-card-text>

        <b-sidebar
          v-if="opened"
          id="fake-app-menu"
          key="fake-app-menu"
          class="fake-app-menu"
          no-header
          v-model="opened"
        >
          <b-row class="px-3 py-2" :style="`${headerStyle}`">
            <b-col cols="3">
              <i class="fas fa-user-circle" style="font-size: 64px"></i>
            </b-col>
            <b-col cols="7" class="fs-18 my-auto">
              <span :style="fontStyle">Faça seu login ou se cadastre</span>
            </b-col>
            <b-col cols="2">
              <i
                class="fas fa-times fs-18 c-pointer"
                :style="`${iconStyle}`"
                @click="opened = false"
              ></i>
            </b-col>
            <b-col cols="12" class="mt-4 mb-2">
              <b-button class="w-100" variant="outline-secondary">
                <i
                  class="fas fa-arrow-circle-right mr-2"
                  :style="`${iconStyle}`"
                ></i>
                <span :style="fontStyle">Login</span>
              </b-button>
            </b-col>
            <hr />
          </b-row>
          <b-row class="mx-1 mt-2 fs-18">
            <b-col cols="12" class="mb-2">
              <i class="fas fa-home mr-2" :style="`${iconStyle}`"></i>
              <span :style="fontStyle">Início</span>
            </b-col>
            <b-col cols="12" class="mb-2">
              <i class="fas fa-envelope-open mr-2" :style="`${iconStyle}`"></i>
              <span :style="fontStyle">Contato</span>
            </b-col>
            <b-col cols="12">
              <i
                class="fas fa-question-circle mr-2"
                :style="`${iconStyle}`"
              ></i>
              <span :style="fontStyle">Ajuda</span>
            </b-col>
          </b-row>
        </b-sidebar>
      </b-card>
    </div>
    <div v-else class="text-center my-2">
      <b-spinner class="align-middle mr-3"></b-spinner>
      <strong>Carregando app de simulação</strong>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import makeToast from 'Mixins/makeToast';

export default {
  name: 'FakeAppTemplate',
  mixins: [makeToast],
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddressApp']),
    iconStyle() {
      return `color: ${this.fields.iconColor.hex8};`;
    },
    fontStyle() {
      return `color: ${this.fields.fontColor.hex8};`;
    },
    backgroundStyle() {
      return `background-color: ${this.fields.backgroundColor.hex8};`;
    },
    headerStyle() {
      return `background-color: ${this.fields.menuHeaderColor.hex8};`;
    },
  },
  watch: {
    opened(newValue) {
      if (!newValue) return;

      setTimeout(() => {
        this.addMenuBackgroundColor();
      }, 10);
    },
    'fields.backgroundColor.hex': function () {
      this.addAppBackgroundColor();
      this.addMenuBackgroundColor();
    },
  },
  data() {
    return {
      opened: false,
      loading: false,
      companyInfo: {},
      fields: {
        menuHeaderColor: {
          hex: '',
          hex8: '',
        },
        backgroundColor: {
          hex: '',
          hex8: '',
        },
        iconColor: {
          hex: '',
          hex8: '',
        },
        fontColor: {
          hex: '',
          hex8: '',
        },
        categories: [],
      },
    };
  },

  props: {
    enable_whatsapp: {
      required: true,
    },
  },

  async mounted() {
    this.loading = true;
    await this.getColors();
    await this.getCompanyInfo();
    await this.categoryCompany();
    this.loading = false;

    this.addMenuBackgroundColor();
    this.addAppBackgroundColor();
  },
  methods: {

    ...mapActions('shopkeeper', [
      'getAboutCompany',
      'listBanner',
      'getMenusApp',
    ]),
    ...mapActions('shopkeeper', ['getCustomization']),
    addMenuBackgroundColor() {
      const menuBackground =
        document.getElementsByClassName('b-sidebar-body')[0];

      if (!menuBackground) return;

      menuBackground.style.backgroundColor = this.fields.backgroundColor.hex;
    },
    addAppBackgroundColor() {
      const appBackground = document.getElementsByClassName('card')[0];

      if (!appBackground) return;

      appBackground.style.backgroundColor =
        this.fields.backgroundColor.backgroundColor;
    },
    async getCompanyInfo() {
      const response = await this.getAboutCompany(this.dadosUsuario.id);

      this.companyInfo = response.data.data || {};
    },
    async categoryCompany() {
      const response = await this.getMenusApp(this.dadosUsuario.id);

      if (!response || !response.data || !response.data.data) {
        this.makeToast(
          'Erro',
          'Houve um erro ao trazer as categorias!',
          'danger'
        );
      }

      this.fields.categories = response.data.data || [];
    },
    async getColors() {
      const response = await this.getCustomization(this.dadosUsuario.id);

      if (!response.data.data) return;

      this.handleColors(response.data.data);
    },
    handleColors({ menuHeaderColor, backgroundColor, iconColor, fontColor }) {
      this.$set(this.fields.menuHeaderColor, 'hex8', menuHeaderColor);
      this.$set(this.fields.menuHeaderColor, 'hex', menuHeaderColor);

      this.$set(this.fields.backgroundColor, 'hex8', backgroundColor);
      this.$set(this.fields.backgroundColor, 'hex', backgroundColor);

      this.$set(this.fields.iconColor, 'hex8', iconColor);
      this.$set(this.fields.iconColor, 'hex', iconColor);

      this.$set(this.fields.fontColor, 'hex8', fontColor);
      this.$set(this.fields.fontColor, 'hex', fontColor);
    },
  },
};
</script>

<style scoped>
body {
  padding: 1rem;
}

>>> .bg-light {
  background-color: transparent !important;
}

.fake-app-menu {
  width: 70%;
  margin-left: 19px;
  margin-top: 50px;
}

>>> .fake-app-menu.b-sidebar-outer {
  position: absolute !important;
  height: 90.1% !important;
}

>>> .fake-app-menu .b-sidebar {
  position: absolute !important;
  height: 100% !important;
}

>>> .b-sidebar > .b-sidebar-body {
  overflow: hidden;
  border-radius: 8px 0 0px 30px;
}

.smartphone-border-radius {
  border-radius: 85px 85px 0 0;
}

.footer-whatsapp {
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
  position: relative;
  top: 15%;
}
</style>